import { createContext } from 'react';
import { IContent } from '../../../../api/contents/interfaces/contentInterface';

/**
 * Seleção de order bumps da compra. `uuid` é o da OFERTA (paym_order_bump) —
 * o único que o pagamento reconhece; `content` carrega título/preço para o
 * resumo. Vários bumps podem ser marcados ao mesmo tempo.
 */
export type OrderBumpSelection = {
	uuid: string;
	content: IContent;
};

interface IOrderBumpContext {
	orderBumps: OrderBumpSelection[];
	/** Liga/desliga uma oferta na compra. */
	toggleOrderBump: (selection: OrderBumpSelection, checked: boolean) => void;
	/**
	 * A tela soma order bumps ao pedido? Só a compra avulsa tem o provider.
	 * Fora dela (assinatura, upsell, downsell, confirmação) o `toggleOrderBump`
	 * padrão não faz nada: o checkbox aparecia, o comprador marcava e a oferta
	 * nunca entrava na cobrança. Quem renderiza o bloco consulta esta flag.
	 */
	enabled: boolean;
}

export const OrderBumpContext = createContext<IOrderBumpContext>({
	orderBumps: [],
	toggleOrderBump: () => false,
	enabled: false
});
